var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTriangleWarningFill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3658 2.37695C10.1871 2.06755 9.857 1.87695 9.49973 1.87695C9.14247 1.87695 8.81234 2.06755 8.63371 2.37695L1.94169 13.9679C1.76306 14.2773 1.76306 14.6585 1.94169 14.9679C2.12033 15.2773 2.45045 15.4679 2.80772 15.4679H16.1917C16.549 15.4679 16.8791 15.2773 17.0578 14.9679C17.2364 14.6585 17.2364 14.2773 17.0578 13.9679L10.3658 2.37695Z",
    fill: "#39556B",
    stroke: "#39556B",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.48122 13.5542C9.22552 13.5542 9.01758 13.3463 9.01758 13.0906C9.01758 12.8349 9.22552 12.627 9.48122 12.627C9.73692 12.627 9.94487 12.8349 9.94487 13.0906C9.94487 13.3463 9.73692 13.5542 9.48122 13.5542Z",
    fill: "#39546A",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.25 10.2176V6.97206C9.25 6.84409 9.35362 6.74023 9.48182 6.74023C9.61002 6.74023 9.71364 6.84409 9.71364 6.97206V10.2176C9.71364 10.3455 9.61002 10.4494 9.48182 10.4494C9.35362 10.4494 9.25 10.3455 9.25 10.2176Z",
    fill: "#39546A",
    stroke: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangleWarningFill);
export default __webpack_public_path__ + "static/media/TriangleWarningFill.d1ad8354061e61276a8242a0337d6d89.svg";
export { ForwardRef as ReactComponent };